.inputs{display:grid;grid-template-columns:25% 75%;align-items:center;row-gap:15px}
/*# sourceMappingURL=preview-workspace.component.css.map */
